/*
 Make multicolum cards clickable
 @todo hover events
 https://www.w3schools.com/howto/howto_js_accordion.asp
 */
document.addEventListener("DOMContentLoaded", function(arg) {
  var cards = document.getElementsByClassName("multicolumn-card");
  for (var i = 0; i < cards.length; i++) {
    var links = cards[i].getElementsByTagName('a');
	if (links.length != 1 || ! links[0].href) { continue; }
    console.log(i+':'+links[0].text+' '+links[0].href);
    (function (link) {
      cards[i].addEventListener("click", function() {
	    window.location.href = link;
      });
    })(links[0].href);
  }
});


/*
 Add LinkedIn icon to footer
*/
document.addEventListener("DOMContentLoaded", function(arg) {
  var list = document.querySelector('.footer ul.footer__list-social');  
  if (list) {
    list.insertAdjacentHTML('afterbegin', '\
  <li class="list-social__item">\
    <a href="https://www.linkedin.com/company/dwl-industries-co./posts/?feedView=all" class="link list-social__link">\
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">\
        <path fill="currentColor" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>\
      </svg>\
      <span class="visually-hidden">LinkedIn</span>\
    </a>\
  </li>\
    ');
  }
});